import StatCard from '../components/ui/StatCard';
import Badge from '../components/ui/Badge';
import Bar from '../components/ui/Bar';

const scoreTrend = [
  { month: 'Okt', score: 42 },
  { month: 'Nov', score: 51 },
  { month: 'Dez', score: 58 },
  { month: 'Jan', score: 55 },
  { month: 'Feb', score: 67 },
  { month: 'Mär', score: 72 },
];

const topCritical = [
  { name: 'CTA-Kontrast', count: 12, category: 'Headlines & CTAs', color: '#0C9488' },
  { name: 'Fehlende Trust-Badges', count: 9, category: 'Trust & Social Proof', color: '#F59E0B' },
  { name: 'LCP > 3s', count: 8, category: 'Page Speed & UX', color: '#10B981' },
  { name: 'Kein Mobile-Menü', count: 7, category: 'Mobile Experience', color: '#3B82F6' },
  { name: 'Formular ohne Validierung', count: 6, category: 'Form Optimierung', color: '#EF4444' },
];

const events = [
  { id: 1, type: 'analysis_created', user: 'David O.', meta: 'shop.example.de', time: 'Vor 2 Stunden' },
  { id: 2, type: 'report_shared', user: 'Anna M.', meta: 'Bericht #12 geteilt', time: 'Vor 3 Stunden' },
  { id: 3, type: 'pdf_generated', user: 'David O.', meta: 'PDF für Bericht #11', time: 'Vor 5 Stunden' },
  { id: 4, type: 'crm_synced', user: 'System', meta: 'Bericht #10 → CRM', time: 'Vor 8 Stunden' },
  { id: 5, type: 'analysis_created', user: 'Thomas K.', meta: 'landing.example.de', time: 'Gestern' },
  { id: 6, type: 'user_invited', user: 'David O.', meta: 'anna@example.de eingeladen', time: 'Gestern' },
];

const eventLabels = {
  analysis_created: { label: 'Analyse', bg: '#E6F4F2', color: '#0C9488' },
  report_shared: { label: 'Geteilt', bg: '#EDE9FE', color: '#8B5CF6' },
  pdf_generated: { label: 'PDF', bg: '#DBEAFE', color: '#3B82F6' },
  crm_synced: { label: 'CRM', bg: '#D1FAE5', color: '#10B981' },
  user_invited: { label: 'User', bg: '#FEF3C7', color: '#F59E0B' },
};

const maxScore = Math.max(...scoreTrend.map((s) => s.score));

export default function Analytics() {
  return (
    <div>
      <div className="mb-5">
        <h1 className="text-[23px] font-bold mb-0.5">Analytics</h1>
        <p className="text-gray-500 text-[13.5px]">Nutzungsstatistiken und Trends</p>
      </div>

      {/* Stat cards */}
      <div className="flex gap-3.5 mb-5 flex-wrap">
        <StatCard label="Analysen gesamt" value="24" sub="diesen Monat: 8" icon="&#x27F3;" iconBg="#E6F4F2" iconColor="#0C9488" />
        <StatCard label="Tokens verbraucht" value="186K" sub="von 500K Limit" icon="&#x25CE;" iconBg="#DBEAFE" iconColor="#3B82F6" />
        <StatCard label="Berichte geteilt" value="12" sub="3 aktive Links" icon="&#x25A4;" iconBg="#EDE9FE" iconColor="#8B5CF6" />
        <StatCard label="Avg. Score" value="72" sub="+14% vs. letzter Monat" icon="&#x25C8;" iconBg="#D1FAE5" iconColor="#10B981" />
      </div>

      <div className="grid grid-cols-[1fr_1fr] gap-4 mb-4">
        {/* Score trend bar chart */}
        <div className="bg-white rounded-xl shadow-sm border border-black/[.07] p-5">
          <h3 className="font-semibold text-[14.5px] mb-4">Score-Trend</h3>
          <div className="flex items-end gap-3 h-[180px]">
            {scoreTrend.map((s) => (
              <div key={s.month} className="flex-1 flex flex-col items-center justify-end h-full">
                <div className="text-[11px] font-semibold text-teal mb-1">{s.score}</div>
                <div
                  className="w-full rounded-t-md transition-all duration-500"
                  style={{
                    height: `${(s.score / maxScore) * 140}px`,
                    background: `linear-gradient(to top, #0C9488, #0C948880)`,
                  }}
                />
                <div className="text-[11px] text-gray-500 mt-2">{s.month}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Top critical factors */}
        <div className="bg-white rounded-xl shadow-sm border border-black/[.07] p-5">
          <h3 className="font-semibold text-[14.5px] mb-4">Top kritische Faktoren</h3>
          <div className="space-y-3.5">
            {topCritical.map((f, i) => (
              <div key={f.name}>
                <div className="flex items-center justify-between mb-1.5">
                  <div className="flex items-center gap-2">
                    <span className="text-[11px] text-gray-400 font-medium w-4">{i + 1}.</span>
                    <span className="text-[13px] font-medium">{f.name}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Badge bg={`${f.color}20`} color={f.color}>{f.category}</Badge>
                    <span className="text-[12px] font-semibold text-gray-700">{f.count}x</span>
                  </div>
                </div>
                <Bar pct={(f.count / 12) * 100} color={f.color} />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Activity event log */}
      <div className="bg-white rounded-xl shadow-sm border border-black/[.07] p-5">
        <h3 className="font-semibold text-[14.5px] mb-4">Aktivitäten</h3>
        <div className="space-y-0">
          {events.map((e) => {
            const ev = eventLabels[e.type] || { label: e.type, bg: '#F3F4F6', color: '#6B7280' };
            return (
              <div key={e.id} className="flex items-center gap-3 py-3 border-b border-gray-100 last:border-0">
                <Badge bg={ev.bg} color={ev.color}>{ev.label}</Badge>
                <div className="flex-1 min-w-0">
                  <span className="text-[13px] font-medium">{e.user}</span>
                  <span className="text-[13px] text-gray-500"> — {e.meta}</span>
                </div>
                <span className="text-[11.5px] text-gray-400 shrink-0">{e.time}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
